import {Injectable} from '@angular/core';
import {Message, MessageService} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private messageService: MessageService) {
  }
  public addToast(message: Message): void {
    this.messageService.clear();
    this.messageService.add(message);
  }

}
